// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomArrow_wrapper__6Arot","left":"CustomArrow_left__2KXCA","right":"CustomArrow_right__cMWhp"};